export {};
declare global {
    interface HTMLElement {
        isScrollable(): boolean;
        scrollParent(): HTMLElement;
    }
}

if (!HTMLElement.prototype.isScrollable) {
    HTMLElement.prototype.isScrollable = function isScrollable(
        this: HTMLElement
    ): boolean {
        const matches = ["auto", "scroll"];
        const styles = getComputedStyle(this);
        return (
            this.scrollHeight > this.clientHeight ||
            matches.includes(
                styles.getPropertyValue("overflow-y")?.toString()
            ) ||
            matches.includes(styles.getPropertyValue("overflow-x")?.toString())
        );
    };
}

if (!HTMLElement.prototype.scrollParent) {
    HTMLElement.prototype.scrollParent = function scrollParent(
        this: HTMLElement
    ): HTMLElement {
        let result = this;
        do {
            result = result.parentElement;

            if (!result) break;
        } while (
            !(result instanceof Document) &&
            result.parentElement &&
            !result.isScrollable()
        );
        return result;
    };
}